import React from "react";

import css from "./ModalForDelete.module.css";

const ModalForDelete = ({ setIsOpenDeleteModal, handleDeleteClick, name }) => {
  return (
    <section className={css.overlay}>
      <div className={css.modal}>
        <button
          className={css.closeButton}
          onClick={() => setIsOpenDeleteModal(false)}
        >
          &times;
        </button>
        <h2 className={css.title}>Deleting {name}!</h2>
        <div className={css.content}>
          <div className={css.warning}>
            <span className={css.warningIcon}>⚠️</span>
            <p>This {name} will be deleted!</p>
          </div>
          <div className={css.actions}>
            <button
              className={css.cancelButton}
              onClick={() => setIsOpenDeleteModal(false)}
            >
              Cancel
            </button>
            <button className={css.okButton} onClick={handleDeleteClick}>
              OK
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export { ModalForDelete };
